import { NavigateFunction } from "react-router-dom";

export const Logout = (navigate: NavigateFunction) => {
  try {
    console.log("Logout function is calling.....");
    // Clear any authentication tokens / user data
    localStorage.removeItem("access-token");
    localStorage.removeItem("user-data"); // optional if you store user info separately
    sessionStorage.clear(); // optional: clear session storage

    // Optionally clear cookies if needed
    document.cookie = "access-token=; Max-Age=0; path=/;";

    // Redirect to login page
    navigate("/login");
  } catch (error) {
    console.error("Logout failed:", error);
  }
};
